import Vue from "vue";
import VeeValidate, { Validator } from "vee-validate";
import ruLocale from "vee-validate/dist/locale/ru";
import i18n from "./localization";

Validator.extend("cyrillicLetters", {
    validate: value => !value.match(/[А-Яа-я]/)
});

Vue.use(VeeValidate, {
    classes: true,
    classNames: {
        invalid: "is-invalid"
    }
});

const customMessages = {
    en: {
        messages: {
            cyrillicLetters: i18n.t("editEnrollments.cyrillicLetters")
        }
    },
    ru: {
        messages: {
            cyrillicLetters: i18n.t("editEnrollments.cyrillicLetters")
        }
    }
};

Validator.localize(customMessages);

if (window.AcademIt.Locale === "ru") {
    Validator.localize("ru", ruLocale);
}
